import { Inbox } from 'lucide-react';

/**
 * "Nothing here yet" and "nothing matched your filters" are different problems
 * with different fixes, so they get different copy and different actions.
 */
export const EmptyState = ({ icon: Icon = Inbox, title, description, action }) => (
  <div className="grid min-h-[280px] place-items-center p-8 text-center">
    <div className="max-w-sm">
      <span className="mx-auto grid h-12 w-12 place-items-center rounded-lg bg-beam-light text-beam-blue">
        <Icon className="h-5 w-5" aria-hidden="true" />
      </span>
      <p className="mt-4 font-display text-2xl font-extrabold">{title}</p>
      {description ? (
        <p className="mt-2 text-sm font-semibold leading-6 text-beam-graphite/60">{description}</p>
      ) : null}
      {action ? <div className="mt-5 flex justify-center">{action}</div> : null}
    </div>
  </div>
);
